import { useReceivedPaymentDetailBodyGeneralInfo } from "./hooks/useReceivedPaymentDetailBodyGeneralInfo"
import './styles.css'

const ReceivedPaymentDetailBodyGeneralInfo = () => {
  const { chargeInstanceDetailData } = useReceivedPaymentDetailBodyGeneralInfo()  
  return (
    <section className="received-payment-detail-body-general-info-container">
      <div className="received-payment-detail-body-general-info">
        <div className="received-payment-detail-body-general-info-item">
          <p>Fecha de emisión</p>
          <span>{chargeInstanceDetailData.charge_data.due_date}</span>
        </div>
        <div className="received-payment-detail-body-general-info-item">
          <p>Fecha de vencimiento</p>
          <span>{chargeInstanceDetailData.charge_data.issue_date}</span>
        </div>
        <div className="received-payment-detail-body-general-info-item">
          <p>Cantidad recaudada</p>
          <span>{chargeInstanceDetailData.charge_data.amount_collected}</span>
        </div>
        <div className="received-payment-detail-body-general-info-item status">
          <p>Estado</p>
          <span>{chargeInstanceDetailData.charge_data.status_name}</span>
        </div>
      </div>
      <div className="received-payment-detail-body-general-info-status-metrics">
        {chargeInstanceDetailData.status_metrics.map((item, index) => ({ ...item, key: index })).map((item) => (
          <div
            key={item.key}
            className="received-payment-detail-body-general-info-status-metrics-item"
            style={{ backgroundColor: item.color }}
          >
            <p>{item.label}</p>
            <span>{item.value}</span>
          </div>))}
      </div>
    </section>
  )
}

export default ReceivedPaymentDetailBodyGeneralInfo
